var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFeather = function SvgFeather(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "feather_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.998 7.995c0 1.592-.632 3.12-1.758 4.245L13.5 19H5v-8.5l6.75-6.75a6.003 6.003 0 0 1 10.248 4.245ZM16 8 2 22M17.5 15H9",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export { SvgFeather as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNMjEuOTk4MyA3Ljk5NTA0QzIxLjk5ODMgOS41ODcyMiAyMS4zNjU4IDExLjExNDIgMjAuMjQgMTIuMjRMMTMuNSAxOUg1VjEwLjVMMTEuNzUgMy43NTAwNEMxMi44NzU4IDIuNjI0MTkgMTQuNDAyOCAxLjk5MTcgMTUuOTk1IDEuOTkxN0MxNy41ODcyIDEuOTkxNyAxOS4xMTQyIDIuNjI0MTkgMjAuMjQgMy43NTAwNEMyMS4zNjU4IDQuODc1ODggMjEuOTk4MyA2LjQwMjg1IDIxLjk5ODMgNy45OTUwNFoiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPjxwYXRoIGQ9Ik0xNiA4TDIgMjIiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPjxwYXRoIGQ9Ik0xNy41IDE1SDkiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPjwvc3ZnPg==";